export function hasTimeSlotShippingMethods(checkout) {
  var _checkout$shippingInf, _checkout$shippingInf2;
  return (_checkout$shippingInf = (_checkout$shippingInf2 = checkout.shippingInfo) == null || (_checkout$shippingInf2 = _checkout$shippingInf2.carrierServiceOptions) == null ? void 0 : _checkout$shippingInf2.some(_ref => {
    var _shippingOptions$some;
    let {
      shippingOptions
    } = _ref;
    return (_shippingOptions$some = shippingOptions == null ? void 0 : shippingOptions.some(_ref2 => {
      var _logistics$deliveryTi;
      let {
        logistics
      } = _ref2;
      return !!(logistics != null && (_logistics$deliveryTi = logistics.deliveryTimeSlot) != null && _logistics$deliveryTi.from);
    })) != null ? _shippingOptions$some : false;
  })) != null ? _checkout$shippingInf : false;
}
//# sourceMappingURL=hasTimeSlotShippingMethods.js.map